import mergeDeepRight from 'ramda/src/mergeDeepRight';
export var extendDeep = function () {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    return objects.filter(Boolean).reduce(mergeDeepRight);
};
//# sourceMappingURL=extend-deep.js.map